import { TaskClosingCodesTemplate } from '../../constants/TaskClosingCodesTemplate';
import { Task, TreeNode } from '../../types/interfaces';
import { TaskCardProps } from '../../types/props';

export const defaultNode: TreeNode = { key: '', label: '' };

export const initState: Task = {
  id: 0,
  externalId: '',
  name: '',
  selectedAction: defaultNode,
  taskType: defaultNode,
  taskStatus: { key: '1', label: 'Новый' },
  asset: defaultNode,
  department: defaultNode,
  employees: [],
  creationDate: '',
  actualStartDate: '',
  plannedStartDate: '',
  plannedEndDate: '',
  actualEndDate: '',
  priority: '',
  description: '',
  possibleStatusTransitions: [],
  actualOperations: [],
  plannedOperations: [],
  attachments: [],
  closeCode: TaskClosingCodesTemplate,
  lastStatusTransitionId: undefined,
  isImported: false,
  hasAttachments: false,
  isClosed: false
};

export const defaultTaskCardProps: TaskCardProps = {
  taskProps: initState
};
